import type { FormKitNode, FormKitSectionsSchema } from '@formkit/core'

// This plugin dynamically adds a description to FormKit node schemas.
// This plugin is intended for use on specific FormKit field types where additional
// descriptive text is beneficial for user comprehension or form accessibility.

export function addDescriptionPlugin(node: FormKitNode) {
  const legends = ['checkbox_multi', 'radio_multi', 'repeater', 'transferlist']
  if (
    ['button', 'submit', 'hidden', 'group', 'list', 'meta'].includes(
      node.props.type,
    )
  ) {
    return
  }

  node.on('created', () => {
    const legendOrLabel = legends.includes(
      `${node.props.type}${node.props.options ? '_multi' : ''}`,
    )
      ? 'legend'
      : 'label'

    if (!node.props.definition) {
      return
    }
    node.props.definition.schemaMemoKey = `unique_${
      node.props.type
    }_${Date.now()}`

    const originalSchemaFn = node.props.definition.schema

    node.props.definition.schema = (
      sectionsSchema: FormKitSectionsSchema = {},
    ) => {
      sectionsSchema[legendOrLabel] = { children: ['$label'] }

      // Extracts description text from node props if it exists
      const descriptionText = node.props.attrs?.description

      // Conditionally adds the description only if it exists
      if (
        descriptionText &&
        sectionsSchema &&
        legendOrLabel in sectionsSchema &&
        sectionsSchema[legendOrLabel] &&
        typeof sectionsSchema[legendOrLabel] === 'object'
      ) {
        // @ts-ignore
        sectionsSchema?.[legendOrLabel].children.push({
          $el: 'span',
          attrs: {
            class: '$classes.description',
          },
          children: [descriptionText],
        })
      }

      if (typeof originalSchemaFn !== 'function') {
        return originalSchemaFn!
      }

      return originalSchemaFn(sectionsSchema)
    }
  })
}
